module.exports = __webpack_public_path__ + "static/img/jingyin2.ae8b5c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/jingyin2.png
// module id = 5msX
// module chunks = 24